import { h } from 'preact';
import { useContext, useMemo } from 'preact/compat';
import { Theme } from '../../lib/render';
import Image, { Fallback } from '../Image';
import AmountButtonGroup from '../inputs/AmountButtonGroup';
import purifyHTML from '../../lib/purify';
import { randomColorVar } from '../../lib/helpers';
import { ConfirmationStepEnum } from './Confirmation';

const Upsell = ({
	setState = null,
}: {
	setState?: (state: ConfirmationStepEnum) => void;
}) => {
	const theme = useContext(Theme);

	const {
		desc,
		title,
		target,
		image,
		amounts,
	} = theme.upsell;

	/**
	 * Use upsell image first,
	 * default to candidate image if not available.
	 */
	// eslint-disable-next-line
	const imageData = useMemo(() => image ? image : (target.image ? target.image : false), [theme]);
	const randomColor = useMemo(() => randomColorVar(), []);

	return (
		<div className="ea-upsell">
			<div className="ea-upsell__text">
				<div className="ea-upsell__text-content">
					{title && <h3 className="ea-upsell__title">{title}</h3>}
					{desc && (
						<div
							className="ea-upsell__desc"
							dangerouslySetInnerHTML={{ __html: purifyHTML(desc) }}
						/>
					)}
				</div>
				<div className="ea-upsell__custom-amount">
					<AmountButtonGroup
						target={target}
						count={2}
						amounts={amounts}
						followUpAction={() => setState?.(ConfirmationStepEnum.FINAL_CONFIRM)}
					/>
				</div>
			</div>
			<div
				className="ea-upsell__image"
				style={{
					'--ea-auto-color': `var(${randomColor})`,
				}}
			>
				{imageData ? (
					<Image
						{...imageData}
						width={500}
						height={400}
					/>
				) : (
					<Fallback />
				)}
			</div>
		</div>
	);
};

export default Upsell;
